<ion-app
	[class.rideops-ui-v2]="rideOpsUi.isV2Active$ | async"
	[class.rideops-ui-v2--nav-collapsed]="v2NavCollapsed$ | async"
>
	<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Shell">
		<ion-split-pane contentId="main-v2" when="(min-width: 0px)">
			<ion-menu contentId="main-v2">
				<ion-content [scrollY]="false">
					<app-menu-bar></app-menu-bar>
				</ion-content>
			</ion-menu>

			<div id="main-v2" class="v2-shell-main">
				<ng-container
					*ngIf="{ banner: v2ReadinessBanner$ | async, downtimeElapsed: v2DowntimeElapsed$ | async } as vm"
				>
					<div
						class="v2-content-panel"
						[class.v2-content-panel--not-ready]="vm.banner?.state === 'not-ready'"
						[class.v2-content-panel--preopening]="vm.banner?.state === 'preopening'"
						[class.v2-content-panel--ready]="vm.banner?.state === 'ready'"
						[class.v2-content-panel--downtime]="vm.banner?.state === 'downtime'"
					>
						<div
							class="v2-status-pill"
							*ngIf="vm.banner as banner"
							[class.v2-status-pill--not-ready]="banner.state === 'not-ready'"
							[class.v2-status-pill--preopening]="banner.state === 'preopening'"
							[class.v2-status-pill--ready]="banner.state === 'ready'"
							[class.v2-status-pill--downtime]="banner.state === 'downtime'"
						>
							<ng-container [ngSwitch]="banner.state">
								<ng-container *ngSwitchCase="'ready'">
									{{ "LOCATION_CLOSED_V2__STATUS_PILL_READY" | transloco }}
								</ng-container>
								<ng-container *ngSwitchCase="'preopening'">
									{{ banner.labelKey | transloco }}
								</ng-container>
								<ng-container *ngSwitchCase="'downtime'">
									{{
										"LOCATION_CLOSED_V2__STATUS_PILL_DOWNTIME"
											| transloco: { elapsed: vm.downtimeElapsed }
									}}
								</ng-container>
								<ng-container *ngSwitchDefault>
									{{ "LOCATION_CLOSED_V2__STATUS_PILL_NOT_READY" | transloco }}
								</ng-container>
							</ng-container>
						</div>

						<app-current-user></app-current-user>
						<ion-router-outlet class="v2-router-outlet"></ion-router-outlet>
						<app-dispatch-undo-toast></app-dispatch-undo-toast>
					</div>
				</ng-container>
			</div>
		</ion-split-pane>
	</ng-container>

	<ng-template #v1Shell>
		<app-current-user></app-current-user>

		<ion-split-pane contentId="main" when="(min-width: 0px)">
			<ion-menu contentId="main">
				<ion-content [scrollY]="false">
					<app-menu-bar></app-menu-bar>
				</ion-content>
			</ion-menu>

			<ion-router-outlet id="main"></ion-router-outlet>
		</ion-split-pane>
	</ng-template>

	<app-environment-bar *ngIf="(rideOpsUi.isV2Active$ | async) !== true"></app-environment-bar>
</ion-app>
